import { gql } from "@apollo/client";

const STUDENT_LOGIN_WITH_OAUTH = gql`
  mutation StudentLoginWithOauth($token: String!) {
    studentLoginWithOauth(token: $token) {
      authenticatable {
        givenName
        familyName
        locale
        activeSubscription {
          status
        }
        currentLanguage {
          id
          englishName
          realName
        }
      }
      credentials {
        uid
        accessToken
        client
      }
    }
  }
`;

export default STUDENT_LOGIN_WITH_OAUTH;
